module.exports = __webpack_public_path__ + "img/OrderActive.8b7953a6.svg";